import { Component } from '@angular/core';
import { MedrecordIcon } from '../../../base/medrecord-icon';

@Component({
  selector: 'medrecord-svg-facebook',
  templateUrl: './facebook.component.svg',
})
export class FacebookComponent extends MedrecordIcon {
  viewHeight = 16;
  viewWidth = 16;
}
